import { getDebugLogger } from '~/utils/getDebugLogger';

export const editorDebug = getDebugLogger('editor');
